import { Collection } from '@api/api';
import { collectionApiClient } from '@api/clients';
import { useCollectionsCount } from '@queries/useCollectionsCount';
import { useQuery, UseQueryResult } from 'react-query';

const limit = 9;

export const fetchCollections = async ({
  pageParam = 0,
}: {
  pageParam?: number;
}): Promise<{ page: number; items: Collection[] }> => {
  const { data } = await collectionApiClient.collectionsGet({
    limit,
    start: pageParam ?? 0,
    sort: 'published_at:DESC',
  });

  return { page: pageParam, items: data };
};

export const useCollections = (page = 0): UseQueryResult & { totalPages: number } => {
  const { data: articlesCount } = useCollectionsCount();

  return {
    totalPages: Math.ceil(articlesCount / limit),
    ...useQuery(
      ['collections', page],
      () =>
        fetchCollections({
          pageParam: page * limit,
        }),
      {
        keepPreviousData: true,
      },
    ),
  };
};
